<template>
  <div class="login" v-if="!loginShow">
    <el-form ref="loginRef" :model="loginForm" :rules="loginRules" class="login-form">
      <h3 class="title">仁和CRM</h3>
      <el-form-item prop="username">
        <el-input
            v-model="loginForm.username"
            type="text"
            size="large"
            auto-complete="off"
            placeholder="工号"
        >
          <template #prefix><svg-icon icon-class="user" class="el-input__icon input-icon" /></template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
            v-model="loginForm.password"
            type="password"
            size="large"
            auto-complete="off"
            placeholder="密码"
            @keyup.enter="handleLogin"
        >
          <template #prefix><svg-icon icon-class="password" class="el-input__icon input-icon" /></template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
            v-model="loginForm.code"
            size="large"
            auto-complete="off"
            placeholder="验证码"
            style="width: 63%"
            @keyup.enter="handleLogin"
        >
          <template #prefix><svg-icon icon-class="validCode" class="el-input__icon input-icon" /></template>
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item>
      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
            :loading="loading"
            size="large"
            type="primary"
            style="width:100%;"
            @click.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div style="float: right;" v-if="register">
          <router-link class="link-type" :to="'/register'">立即注册</router-link>
        </div>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>Copyright © 2018-2023 rhkj.com All Rights Reserved.</span>
    </div>

    <must-modify-pwd-dialog
        v-model:visible="pwdDiaVis"
        :access-token="currentAccToken"
    />
  </div>
</template>

<script setup>
import { initTccc } from '@/utils/Tccc'
import {getCodeImg, login} from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import useUserStore from '@/store/modules/user'
import MustModifyPwdDialog from "@/views/system/user/profile/MustModifyPwdDialog";
import { ElMessageBox } from "element-plus";
import { loginWeComSidebar } from "@/api/mainLogin";
import { isQw } from "@/utils/qwSdk.js";
const userStore = useUserStore()
const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
const loginShow = ref(true);

if (isQw() && !location.href.includes("noAuth_qw")) {
  initQiwei();
} else {
  loginShow.value = false;
}

function initQiwei() {
  const { redirect, state, code } = route.query;

  if (state === "qiwei") {
    if (!code) {
      gotoAuthConfirm();
    } else {
      loginWeComSidebar({ code })
        .then((res) => {
          if (res.code == 200) {
            console.log(redirect);
            if (location.href.includes("debug_qw")) {
              ElMessageBox.alert("登录成功", { confirmButtonText: "确定", type: "success", "show-close": false, }).then(() => {
                location.href = `${location.origin}${decodeURIComponent(redirect)}`;
              });
            } else {
              location.href = `${location.origin}${decodeURIComponent(redirect)}`;
            }
          } else {
            gotoAuthConfirm();
          }
        })
        .catch(() => {
          gotoAuthConfirm();
        });
    }
  } else {
    gotoAuth();
  }

  function gotoAuthConfirm() {
    ElMessageBox.alert("授权登录失败", "系统提示", { confirmButtonText: "重新登录", type: "warning", "show-close": false, }).then(() => {
      gotoAuth();
    });
  }

  function gotoAuth() {
    let search = decodeURIComponent(redirect);
    search = search.substring(search.indexOf("?"));
    const { appid, agentid } = getParams(search) || {};

    const redirect_uri = encodeURIComponent(`${location.origin}${route.path}?redirect=${encodeURIComponent(redirect)}`);
    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_privateinfo&state=qiwei&agentid=${agentid}#wechat_redirect`;
    console.log(route);

    if (location.href.includes("debug_qw")) {
      ElMessageBox.alert("前去授权", { confirmButtonText: "确定", type: "warning", "show-close": false, }).then(() => {
        location.href = authUrl;
      });
    } else {
      location.href = authUrl;
    }
  }

  function getParams(search) {
    const pa = search.substr(1).split("&");
    const s = {};
    for (let i = 0; i < pa.length; i++) {
      s[pa[i].split("=")[0]] = decodeURIComponent(pa[i].split("=")[1]);
    }
    return s;
  }
}

const loginForm = ref({
  username: "",
  password: "",
  rememberMe: false,
  code: "",
  uuid: ""
});

const loginRules = {
  username: [{ required: true, trigger: "blur", message: "请输入您的账号" }],
  password: [{ required: true, trigger: "blur", message: "请输入您的密码" }],
  code: [{ required: true, trigger: "change", message: "请输入验证码" }]
};

const codeUrl = ref("");
const loading = ref(false);
// 验证码开关
const captchaEnabled = ref(true);
// 注册开关
const register = ref(false);

const pwdDiaVis = ref(false)
const currentAccToken = ref('')

function handleLogin() {
  proxy.$refs.loginRef.validate(valid => {
    if (valid) {
      loading.value = true;
      // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
      if (loginForm.value.rememberMe) {
        Cookies.set("username", loginForm.value.username, { expires: 30 });
        Cookies.set("password", encrypt(loginForm.value.password), { expires: 30 });
        Cookies.set("rememberMe", loginForm.value.rememberMe, { expires: 30 });
      } else {
        // 否则移除
        Cookies.remove("username");
        Cookies.remove("password");
        Cookies.remove("rememberMe");
      }

      const username = loginForm.value.username.trim()
      const password = loginForm.value.password
      const code = loginForm.value.code
      const uuid = loginForm.value.uuid

      login(username, password, code, uuid)
          .then(res => {
            const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[~!#@$%^*&()_+{}\[\]|\\;:'",<.>\/?])[a-zA-Z\d~!#@$%^*&()_+{}\[\]|\\;:'",<.>\/?]*$/

            if (!pattern.test(password)) {
              currentAccToken.value = res.data.access_token
              loading.value = false;
              pwdDiaVis.value = true
            } else {
              userStore.loginNew(res).then(() => {
                //登录成功初始化外呼
                initTccc(true)
                if (route.query.redirect) {
                  location.href = decodeURIComponent(route.query.redirect);
                } else {
                  router.push({ path: "/" });
                }
              })
            }
          })
          .catch(error => {
            loading.value = false;
            // 重新获取验证码
            if (captchaEnabled.value) {
              getCode();
            }
          })
    }
  });
}

function getCode() {
  getCodeImg().then(res => {
    captchaEnabled.value = res.captchaEnabled === undefined ? true : res.captchaEnabled;
    if (captchaEnabled.value) {
      codeUrl.value = "data:image/gif;base64," + res.img;
      loginForm.value.uuid = res.uuid;
    }
  });
}

function getCookie() {
  const username = Cookies.get("username");
  const password = Cookies.get("password");
  const rememberMe = Cookies.get("rememberMe");
  loginForm.value = {
    username: username === undefined ? loginForm.value.username : username,
    password: password === undefined ? loginForm.value.password : decrypt(password),
    rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
  };
}

getCode();
getCookie();
</script>

<style lang='scss' scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/images/login-background.jpg");
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 40px;
    input {
      height: 40px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 0px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 40px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 40px;
  padding-left: 12px;
}
</style>
